const React = require('react');

const SkipLink = (props) => {

    const onClick = (event) => {
        event.preventDefault();

        const container = document.querySelector(props.skipTo);
        
        if (container) {
            container.tabIndex = -1;
            container.focus();
            setTimeout(() => container.removeAttribute("tabindex"), 1000);
        }
    };

    return React.cloneElement(props.children, { onClick, id: props.id });
}

SkipLink.defaultProps = {
    id: "skip-link",
    skipTo: ".article, article",
};

module.exports = SkipLink;


// WEBPACK FOOTER //
// ./src/common/SkipLink/SkipLink.js